<template>
    <b-modal
        :id="modalId"
        size="xl"
        hide-footer
        body-class="overflow-auto"
        centered
        :title="$t('offers')"
        @hidden="handleHidden()"
    >
        <DataTable :fields="fields" :items="items" no-padding>
            <template #cell(campaign)="{item}">
                <div class="d-flex align-items-center gap-2">
                    <ImageLoader :src="item.campaignIcon" :size="14" />
                    <b-link :href="item.campaignUrl" target="_blank" class="text-secondary">{{ item.campaign }}</b-link>
                </div>
            </template>
            <template #cell(offer)="{item}">
                <b-link :href="item.url" target="_blank" class="text-secondary">{{ item.name }}</b-link>
            </template>
        </DataTable>
    </b-modal>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';

    export default {
        name: 'ModalNumberOfOffersItem',
        components: {
            DataTable,
            ImageLoader,
        },
        data() {
            return {
                modalId: 'ModalNumberOfOffersItem',
                item: null,
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'campaign', label: this.$t('campaign') },
                    { key: 'offer', label: this.$t('offer') },
                ];
            },
            items() {
                return this.item?.activeOffers || [];
            },
        },
        methods: {
            initItem(item) {
                this.item = item;
            },
            handleHidden() {
                this.item = null;
            },
        },
        mounted() {
            this.$root.$on(this.modalId, this.initItem);
        },
        beforeDestroy() {
            this.$root.$off(this.modalId, this.initItem);
        },
    };
</script>
